import { render, staticRenderFns } from "./SnackbarLimit.vue?vue&type=template&id=555bda2b&"
import script from "./SnackbarLimit.vue?vue&type=script&lang=ts&"
export * from "./SnackbarLimit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports